module.exports = __webpack_public_path__ + "9c0229f20db98ab07c51537059505006.png";